<!-- DynamicGroupForm.vue -->
<template>
  <el-form
    :label-width="labelWidth"
    :model="modelValue"
    :rules="rules"
    :ref="setFormRef"
  >
    <el-form-item
      v-for="(field, index) in fields"
      :key="index"
      :label="field.label"
      :prop="field.prop"
      class="group-form-item"
    >
      <!-- 级联选择器 -->
      <el-cascader
        v-if="field.component === 'el-cascader'"
        :id="field.prop"
        :placeholder="field.placeholder"
        :options="field.options"
        :model-value="modelValue[field.prop]"
        @update:modelValue="value => updateField(field.prop, value)"
        style="width:100%"
      />
      <!-- radio 选项 -->
      <template v-else-if="field.component === 'el-radio-group'">
        <el-radio-group
          :is="field.component"
          :id="field.prop"
          :type="field.type"
          :model-value="modelValue[field.prop]"
          :disabled="readonly || field.readonly"
          @update:modelValue="value => updateField(field.prop, value)"
          style="width:100%"
        >
          <el-radio
            v-for="(option, optionIndex) in field.options"
            :key="optionIndex"
            :label="option.value"
          >
            {{ option.label }}
          </el-radio>
        </el-radio-group>
      </template>
      <!-- 其他字段 -->
      <component
        v-else
        :is="field.component"
        :id="field.prop"
        :type="field.type"
        :placeholder="field.placeholder"
        :min="field.min"
        :max="field.max"
        :filterable="field.filterable"
        :disabled="field.disabled"
        :multiple="field.multiple"
        :readonly="readonly || field.readonly"
        :remote="field.remote"
        :remote-method="field.remoteMethod"
        :loading="field.loading"
        :model-value="modelValue[field.prop]"
        @update:modelValue="value => updateField(field.prop, value)"
        clearable
        :show-password="field.showPassword"
        style="width:100%"
      >
        <!-- Select 选项 -->
        <template v-if="field.component === 'el-select'">
          <el-option
            v-for="option in field.options"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          />
        </template>
      </component>
    </el-form-item>
  </el-form>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    groupIndex: {
      type: Number,
      required: true
    },
    fields: {
      type: Array,
      default: () => []
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    readonly: {
      type: Boolean,
      default: false
    },
    labelWidth: {
      type: String,
      default: '100px'
    }
  },

  emits: ['set-form-ref', 'update:modelValue'],

  setup(props, context) {
    const { t } = useI18n()

    const setFormRef = (el: any) => {
      context.emit('set-form-ref', props.groupIndex, el)
    }

    const updateField = (prop: string, value: any) => {
      const newModel = { ...props.modelValue, [prop]: value }
      context.emit('update:modelValue', newModel)
    }

    return {
      t,
      setFormRef,
      updateField
    }
  }
})
</script>

<style scoped>
.group-form-item {
  margin-bottom: 22px;
}
</style>
